export class DefinicaoSenhaModel{
	DefinicaoHash:string;
	SenhaConfirma:string;
	Senha:string;
}


// WEBPACK FOOTER //
// ./src/app/login/definicao-senha/definicao-senha.model.ts